/**
 * The perk branch registry.
 *
 * One import and one entry per branch, and nothing else. `PERK_BRANCH_ORDER` is the order the
 * columns are drawn in and the order anything walking the tree uses, so the screen and the tests
 * agree without either deciding.
 */

import { GUNPLAY_BRANCH } from '@/sim/progression/perkBranches/gunplay';
import { SCAVENGING_BRANCH } from '@/sim/progression/perkBranches/scavenging';
import { SURVIVAL_BRANCH } from '@/sim/progression/perkBranches/survival';
import type { PerkBranch, PerkBranchId } from '@/sim/progression/perkBranchContract';

export const PERK_BRANCHES = {
  gunplay: GUNPLAY_BRANCH,
  survival: SURVIVAL_BRANCH,
  scavenging: SCAVENGING_BRANCH,
} as const satisfies Record<PerkBranchId, PerkBranch>;

/** Column order, and the order anything walking the tree uses. */
export const PERK_BRANCH_ORDER: readonly PerkBranchId[] = ['gunplay', 'survival', 'scavenging'];

/** Branch lookup, total over the union so it never widens to `undefined`. */
export function perkBranch(id: PerkBranchId): PerkBranch {
  return PERK_BRANCHES[id];
}

/** Whether `value` names a branch. */
export function isPerkBranchId(value: string): value is PerkBranchId {
  return Object.hasOwn(PERK_BRANCHES, value);
}
